"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyInput = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var LOCALE = 'en-us';
var currencyFormatter = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'USD'
});

var currencyParser = function currencyParser(val) {
  try {
    // for when the input gets clears
    if (typeof val === 'string' && !val.length) {
      val = '0.0';
    } // detecting and parsing between comma and dot


    var group = new Intl.NumberFormat(LOCALE).format(1111).replace(/1/g, '');
    var decimal = new Intl.NumberFormat(LOCALE).format(1.1).replace(/1/g, '');
    var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.'); //  => 1232.21 €
    // removing everything except the digits and dot

    reversedVal = reversedVal.replace(/[^\d.]/g, ''); //  => 1232.21
    // appending digits properly

    var digitsAfterDecimalCount = (reversedVal.split('.')[1] || []).length;
    var needsDigitsAppended = digitsAfterDecimalCount > 2;

    if (needsDigitsAppended) {
      reversedVal = reversedVal * Math.pow(10, digitsAfterDecimalCount - 2);
    }

    return Number.isNaN(reversedVal) ? 0 : reversedVal;
  } catch (error) {
    console.error(error);
  }
};

function CurrencyInput(props) {
  return react_1["default"].createElement(antd_1.InputNumber, Object.assign({
    precision: 2,
    style: Object.assign({
      width: 200
    }, props.style)
  }, props, {
    formatter: function formatter(value) {
      return currencyFormatter.format(value);
    },
    parser: currencyParser
  }));
}

exports.CurrencyInput = CurrencyInput;